var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterWrapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 132,
    viewBox: "0 0 127 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4090_64535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 113,
    height: 113
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35192 55.879C7.16832 66.973 10.2786 77.8723 16.2894 87.1987C22.3002 96.525 30.9417 103.859 41.1209 108.275C51.3002 112.69 62.56 113.987 73.4767 112.003C84.3934 110.019 94.4765 104.842 102.451 97.1271C110.425 89.4124 115.933 79.5061 118.278 68.6611C120.622 57.8161 119.698 46.5194 115.622 36.1996C111.546 25.8799 104.502 17.0004 95.3796 10.6842C86.2573 4.368 75.4669 0.898707 64.3729 0.715031C64.0559 0.707031 63.7389 0.707031 63.4269 0.707031C48.712 0.711575 34.588 6.49744 24.0988 16.8177C13.6097 27.1379 7.59533 41.1661 7.35192 55.879Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4090_64535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8993 -54.2766L-47.8982 43.665L49.991 168.396L174.788 70.454L76.8993 -54.2766Z",
    fill: "url(#paint0_linear_4090_64535)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4090_64535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 127,
    height: 132
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.114 0.707031H0.776855V131.802H126.114V0.707031Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4090_64535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.144 56.8079C117.144 67.4288 113.994 77.8111 108.094 86.642C102.193 95.4729 93.8064 102.356 83.994 106.42C74.1816 110.485 63.3843 111.548 52.9676 109.476C42.5508 107.404 32.9824 102.29 25.4723 94.7795C17.9622 87.2695 12.8478 77.701 10.7758 67.2843C8.70372 56.8675 9.76716 46.0702 13.8316 36.2578C17.896 26.4454 24.7789 18.0586 33.6098 12.158C42.4407 6.25736 52.8231 3.10791 63.4439 3.10791C77.686 3.10791 91.3448 8.76557 101.416 18.8363C111.486 28.907 117.144 42.5658 117.144 56.8079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4449 131.802L53.4449 118.68C38.7484 116.302 25.3783 108.77 15.7282 97.4335C6.0781 86.0969 0.778023 71.6957 0.776855 56.8081H2.09186C2.01758 71.4476 7.21072 85.6257 16.7232 96.7537C26.2357 107.882 39.433 115.218 53.9059 117.422L54.1669 117.464L63.4459 129.635L72.7249 117.464L72.9849 117.422C87.4579 115.218 100.655 107.882 110.168 96.754C119.681 85.6259 124.874 71.4478 124.8 56.8081H126.115C126.114 71.6955 120.814 86.0964 111.164 97.4329C101.515 108.769 88.1449 116.301 73.4489 118.68L63.4449 131.802Z",
    fill: "#008556"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4090_64535",
    x1: 60.2559,
    y1: 154.495,
    x2: 61.2543,
    y2: 153.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#D6D6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterWrapper);
export default __webpack_public_path__ + "static/media/letterWrapper.122b28da39ea512c28d73cf3bd071ca1.svg";
export { ForwardRef as ReactComponent };